__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/9f9953023faf9ce8a992c40ed7d5f121598dbd1f4684622122afe68c/";